import type { RecordingPolicyFetchedAction } from '@Application/RecordingPolicy/Actions/recordingPolicyFetched';
import RecordingPolicyView from '@UI/Store/RecordingPolicy/Views/RecordingPolicyView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type RecordingPolicyStore = {
	policy: RecordingPolicyView | null;
};

const initialState: RecordingPolicyStore = {
	policy: null,
};

type Actions = RecordingPolicyFetchedAction;

const whenRecordingPolicyFetched = (
	store: RecordingPolicyStore,
	action: RecordingPolicyFetchedAction,
): RecordingPolicyStore => ({
	...store,
	policy: new RecordingPolicyView(action.payload),
});

export default registerStore<'recordingPolicyStore', Actions>(
	'recordingPolicyStore',
	createSliceReducer({
		RECORDING_POLICY_FETCHED: whenRecordingPolicyFetched,
	}),
	initialState,
);
